export const UNMAPPED_COLORS = {
  blueGradient: '#03a9f4',
  lightBlueGradient: '#E8F6FC',
  lightRedGradient: '#F8E8E8',
  lightPurpleGradient: '#F2EEF9',
  lightYellowGradient: '#FEF2E6',
  lightOrangeGradient: '#FEF2E6',
  lightGreenGradient: '#EDF7EE',
  darkGrayGradient: '#3E3E3E',
  blueGradient2: '#02557a',
  darkGrayShade: '#686868',
  timePickerArrowDisabledBgColor: '#cccccc',
  timePickerArrowDisabledColor: '#666666',
  timePickerArrowHoverBgColor: '#03A9F40F',
  lightOrangeShade: '#FCD6B0',
  amberLighter: '#FFF8E1',
  amberLight: '#FFECB3',
  amber: '#FFE082',
  amberDark: '#92400E',
  darkOrangeShade: '#874400',
}
